import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { DEBUG } from "../env";
import Package from "../package.json";
import Api from "./js/Api";
import SocketConnection from "./js/Socket";
import VueMasonry from "vue-masonry-css";
import VueConfetti from "vue-confetti";
import Notifications from "vue-notification";

Vue.use(Notifications);

//eslint-disable-next-line no-unused-vars
import { VueReCaptcha } from "vue-recaptcha-v3";

import "/src/css/style.css";

console.log("Version", Package.version);

const API = new Api();
Vue.config.productionTip = false;
Vue.prototype.$DEBUG = DEBUG;
Vue.prototype.$API = API;
Vue.prototype.$SOCKET = SocketConnection;
Vue.use(VueMasonry);
Vue.use(VueConfetti);
if (window.location.pathname.toString().indexOf("circuito/inscripcion") == -1) {
  // siteKey: "6Le8XlQeAAAAAKmlamDJVakF1iE_CGmyAqXyd57x"

  Vue.use(VueReCaptcha, {
    siteKey: "6LePP-srAAAAADs-K6B7qEFd1rTwophimNEBBxmy"
  });
}

// #339: ID de GA4 por instalación. Sin ID no se carga gtag (index.html) y acá no se llama.
const GA_ID = process.env.VUE_APP_GA_ID;
router.beforeEach((to, from, next) => {
  if (GA_ID && typeof window.gtag === "function") {
    window.gtag("config", GA_ID, {
      page_path: to.fullPath,
      page_title: document.title + " - " + to.path
    });
  }
  next();
});

// Vue.config.errorHandler = function (err, vm, info) {
//   console.log("error",err, vm, info)
// }

new Vue({
  router,
  store,
  vuetify,

  render: h => h(App)
}).$mount("#app");
